import { fetchPrices } from './reducer/fetch-prices'

export {
  fetchPrices
}